import { render } from "./ApprovedLiquidations.vue?vue&type=template&id=3e50967b"
import script from "./ApprovedLiquidations.vue?vue&type=script&lang=js"
export * from "./ApprovedLiquidations.vue?vue&type=script&lang=js"

import "./ApprovedLiquidations.vue?vue&type=style&index=0&id=3e50967b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__